import {Pipe} from "@angular/core";

@Pipe({standalone: true, name: 'orderBy'})
export class OrderByPipe {

    transform<T, K extends keyof T>(value: T[], key?: K): T[] {
        return key
            ? this.withArgs(value, key)
            : this.withoutArgs(value);
    }

    withoutArgs<T>(value: T[]): T[] {
        return value?.sort();
    }

    withArgs<T, K extends keyof T>(value: T[], key: K): T[] {
        return value?.sort((a, b) => {
            if (a[key] === b[key]) {
                return 0;
            }

            return a[key] < b[key]
                ? -1
                : 1;
        })
    }
}